import React, { useState, useMemo } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import SideMenu from '../navbar/SideMenu';
import SideMenuBurunga from '../navbar/SideMenuBurunga'; 
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TextField,
  List, 
  ListItem, 
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack
} from '@mui/material';

import {
  ExpandLess,
  Search,
  Menu as MenuIcon,
  ExpandMore,
  LocationOn,
  TrendingUp,
  TrendingDown,
  Group
} from '@mui/icons-material';

const drawerWidth = 240;
const rightDrawerWidth = 280;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const RightDrawerWrapper = styled('div')(({ theme }) => ({
  width: rightDrawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    right: 0,
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(100%)',
    },
  }
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  backgroundColor: '#f0f0f0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#e8e8e8 !important'
  }
});

const populationData = {
  title: "RÉPARTITION DE LA POPULATION DE LA PROVINCE DE BURUNGA PAR COMMUNE",
  provinces: [
    {
      id: "1",
      name: "BURUNGA",
      total: 2097855,
      urbain: 417109,
      rural: 1680746,
      proportionUrbain: 19.9,
      proportionRural: 80.1,
      masculin: 1001718,
      feminin: 1096137,
      rapportMasculinite: 91,
      communes: [
        {
          id: "101",
          name: "BURURI",
          total: 182930,
          urbain: 10112,
          rural: 172818,
          proportionUrbain: 5.5,
          proportionRural: 94.5,
          masculin: 85299,
          feminin: 97631,
          rapportMasculinite: 87
        },
        {
          id: "102",
          name: "MAKAMBA",
          total: 368668,
          urbain: 74963,
          rural: 293705,
          proportionUrbain: 20.3,
          proportionRural: 79.7,
          masculin: 173859,
          feminin: 194809,
          rapportMasculinite: 89
        },
        {
          id: "103",
          name: "MATANA",
          total: 191889,
          urbain: 11942,
          rural: 179947,
          proportionUrbain: 6.2,
          proportionRural: 93.8,
          masculin: 91478,
          feminin: 100411,
          rapportMasculinite: 91
        },
        {
          id: "104",
          name: "MUSONGATI",
          total: 335150,
          urbain: 36949,
          rural: 298201,
          proportionUrbain: 11.0,
          proportionRural: 89.0,
          masculin: 160548,
          feminin: 174602,
          rapportMasculinite: 92
        },
        {
          id: "105",
          name: "NYANZA",
          total: 366682,
          urbain: 112582,
          rural: 254100,
          proportionUrbain: 30.7,
          proportionRural: 69.3,
          masculin: 177396,
          feminin: 189286,
          rapportMasculinite: 94
        },
        {
          id: "106",
          name: "RUMONGE",
          total: 426929,
          urbain: 127317,
          rural: 299612,
          proportionUrbain: 29.8,
          proportionRural: 70.2,
          masculin: 204588,
          feminin: 222341,
          rapportMasculinite: 92
        },
        {
          id: "107",
          name: "RUTANA",
          total: 225607,
          urbain: 43244,
          rural: 182363,
          proportionUrbain: 19.2,
          proportionRural: 80.8,
          masculin: 108550,
          feminin: 117057,
          rapportMasculinite: 93
        }
      ]
    }
  ]
};

const PopulationDataPageBurunga = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [rightMobileOpen, setRightMobileOpen] = useState(false);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  const [openKeyStats, setOpenKeyStats] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleRightDrawerToggle = () => {
    setRightMobileOpen(!rightMobileOpen);
  };

  const toggleProvince = (provinceId) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceId]: !prev[provinceId]
    }));
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data;
    
    const filteredProvinces = data.provinces.map(province => {
      const filteredCommunes = province.communes.filter(commune =>
        commune.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      return {
        ...province,
        communes: filteredCommunes,
        show: filteredCommunes.length > 0 || 
              province.name.toLowerCase().includes(searchTerm.toLowerCase())
      };
    }).filter(province => province.show || !searchTerm);
    
    return {
      ...data,
      provinces: filteredProvinces
    };
  };

  const filteredData = filterData(populationData, searchTerm);

  const keyStats = useMemo(() => {
    const province = populationData.provinces[0];
  
    const mostPopulatedCommune = province.communes.reduce((max, commune) => 
      commune.total > max.total ? commune : max, province.communes[0]);
    
    const leastPopulatedCommune = province.communes.reduce((min, commune) => 
      commune.total < min.total ? commune : min, province.communes[0]);
    
    const communePercentages = province.communes.map(commune => ({
      ...commune,
      percentage: ((commune.total / province.total) * 100).toFixed(1)
    }));
    
    const totalUrbain = province.communes.reduce((sum, commune) => sum + commune.urbain, 0);
    const totalRural = province.communes.reduce((sum, commune) => sum + commune.rural, 0);
    const totalMasculin = province.communes.reduce((sum, commune) => sum + commune.masculin, 0);
    const totalFeminin = province.communes.reduce((sum, commune) => sum + commune.feminin, 0);
    
    return {
      totalPopulation: province.total.toLocaleString(),
      totalCommunes: province.communes.length,
      mostPopulatedCommune,
      leastPopulatedCommune,
      communePercentages,
      totalUrbain,
      totalRural,
      totalMasculin,
      totalFeminin,
      provinceTotal: province.total
    };
  }, []);

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            <SideMenu /> 
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            <SideMenu /> 
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
                <Button 
                  variant="outlined" 
                  endIcon={<MenuIcon />} 
                  onClick={handleRightDrawerToggle}
                  sx={{ color: secondaryColor, borderColor: secondaryColor }}
                >
                  Info Burunga
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="body1" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {populationData.title}
                    </Typography>
                    <Chip 
                      icon={<Group />} 
                      label={`Province de BURUNGA`} 
                      color="primary" 
                      variant="outlined" 
                    />
                  </Box>
                  
                  <Grid container spacing={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6}></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher province/commune..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '380px' } }}
                      />
                    </Grid>
                  </Grid>
                  
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                         Province de BURUNGA
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Totale
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="primary">
                                {keyStats.totalPopulation}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Communes
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="secondary">
                                {keyStats.totalCommunes}
                              </Typography>
                              <Typography variant="caption">
                                Communes répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Commune la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedCommune.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulatedCommune.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.mostPopulatedCommune.total / keyStats.provinceTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Commune la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedCommune.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.leastPopulatedCommune.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.leastPopulatedCommune.total / keyStats.provinceTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Urbaine
                              </Typography>
                              <Typography variant="h4" fontWeight="bold">
                                {keyStats.totalUrbain.toLocaleString()}
                              </Typography>
                              <Typography variant="caption">
                                ({((keyStats.totalUrbain / keyStats.provinceTotal) * 100).toFixed(1)}%)
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Rurale
                              </Typography>
                              <Typography variant="h4" fontWeight="bold">
                                {keyStats.totalRural.toLocaleString()}
                              </Typography>
                              <Typography variant="caption">
                                ({((keyStats.totalRural / keyStats.provinceTotal) * 100).toFixed(1)}%)
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Masculine
                              </Typography>
                              <Typography variant="h4" fontWeight="bold">
                                {keyStats.totalMasculin.toLocaleString()}
                              </Typography>
                              <Typography variant="caption">
                                ({((keyStats.totalMasculin / keyStats.provinceTotal) * 100).toFixed(1)}%)
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Féminine
                              </Typography>
                              <Typography variant="h4" fontWeight="bold">
                                {keyStats.totalFeminin.toLocaleString()}
                              </Typography>
                              <Typography variant="caption">
                                ({((keyStats.totalFeminin / keyStats.provinceTotal) * 100).toFixed(1)}%)
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>

                      {/* Répartition par commune avec barres de progression */}
                      <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                          Répartition de la population par commune
                        </Typography>
                        {keyStats.communePercentages.map((commune) => (
                          <Box key={commune.id} sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography variant="body2">
                                {commune.name}
                              </Typography>
                              <Typography variant="body2" fontWeight="bold">
                                {commune.percentage}% ({commune.total.toLocaleString()})
                              </Typography>
                            </Box>
                            <LinearProgress 
                              variant="determinate" 
                              value={commune.percentage} 
                              sx={{ 
                                height: 8, 
                                borderRadius: 4,
                                backgroundColor: '#e0e0e0',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: commune.id === keyStats.mostPopulatedCommune.id ? primaryColor : 
                                                commune.id === keyStats.leastPopulatedCommune.id ? secondaryColor : '#888',
                                }
                              }} 
                            />
                          </Box>
                        ))}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Province/Commune</TableCell>
                          <TableCell align="right">Population Totale</TableCell>
                          <TableCell align="right">Urbain</TableCell>
                          <TableCell align="right">Rural</TableCell>
                          <TableCell align="right">% Urbain</TableCell>
                          <TableCell align="right">% Rural</TableCell>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                          <TableCell align="right">Rapport M/F</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Données par province et commune */}
                        {filteredData.provinces.map((province) => (
                          <React.Fragment key={province.id}>
                            <ProvinceRow 
                              hover 
                              onClick={() => toggleProvince(province.id)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row" colSpan={8}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedProvinces[province.id] ? <ExpandLess /> : <ExpandMore />}
                                  <LocationOn sx={{ mr: 1, color: primaryColor }} />
                                  {province.name}
                                </Box>
                              </TableCell>
                              <TableCell align="right"></TableCell>
                            </ProvinceRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={9}>
                                <Collapse in={expandedProvinces[province.id] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {province.communes.map((commune) => (
                                        <CommuneRow key={commune.id} hover>
                                          <TableCell sx={{ pl: 4 }}>{commune.name}</TableCell>
                                          <TableCell align="right">{commune.total.toLocaleString()}</TableCell>
                                          <TableCell align="right">{commune.urbain.toLocaleString()}</TableCell>
                                          <TableCell align="right">{commune.rural.toLocaleString()}</TableCell>
                                          <TableCell align="right">{commune.proportionUrbain}%</TableCell>
                                          <TableCell align="right">{commune.proportionRural}%</TableCell>
                                          <TableCell align="right">{commune.masculin.toLocaleString()}</TableCell>
                                          <TableCell align="right">{commune.feminin.toLocaleString()}</TableCell>
                                          <TableCell align="right">{commune.rapportMasculinite}</TableCell>
                                        </CommuneRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Structure administrative - Province de BURUNGA
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      La province de BURUNGA est divisée en 7 communes administratives:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      {keyStats.communePercentages.map((commune, index) => (
                        <ListItem key={commune.id}>
                          <ListItemText 
                            primary={`${index + 1}. ${commune.name}`} 
                            secondary={`Population: ${commune.total.toLocaleString()} habitants (${commune.percentage}%)`} 
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population. 
                    Les chiffres incluent uniquement la population des ménages ordinaires.
                    Les pourcentages sont calculés par rapport à la population totale de la province de BURUNGA ({keyStats.totalPopulation} habitants).
                    Le rapport de masculinité est calculé comme le nombre d'hommes pour 100 femmes.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>

        {/* SideMenuBurunga à droite */}
        {!isMobile ? (
          <RightDrawerWrapper>
            <SideMenuBurunga />
          </RightDrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            anchor="right"
            open={rightMobileOpen}
            onClose={handleRightDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: rightDrawerWidth },
            }}
          >
            <SideMenuBurunga />
          </Drawer>
        )}
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default PopulationDataPageBurunga;